import { EUserRoles } from '@enums/common';

export const generateDefaultAccessPermission: Record<string, boolean> = Object
	.keys(EUserRoles)
	.reduce<Record<string, boolean>>((acc, role) => {
		acc = { ...acc, [role]: false };

		return acc;
	}, {});

export const checkGroupPanelAccess = <T extends string, >(
	accessPermission: Record<T, boolean>, accessRoles: T[],
): boolean => {
	return accessRoles.some((role) => accessPermission[role]);
};
